export default "__VITE_ASSET__Bh9Scr_t__"